import { AuthEnums } from "models/enums";
import { ApiClientInstance, FileHelper } from "utils/helpers";
import { WintSuperkollAPIModelAccounting } from "wint-api-client/dist/types";
import useAPIClientHelper from "./useAPIClientHelper";

function useVoucherService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getVoucher = (id: string) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .VoucherClient.GetById(id)
      .then((res) => res.data);
  };

  const getSeries = (exactShortName: string) => {
    return apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true })
      .SeriesClient.Get({
        exactShortName: exactShortName,
      } as WintSuperkollAPIModelAccounting.SeriesFilter)
      .then((res) => res.data);
  };

  const postVoucher = async (post: WintSuperkollAPIModelAccounting.VoucherPost) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .VoucherClient.Post(post)
      .then((res) => res.data);
  };

  const downloadVoucher = (id: string) => {
    apiClientInstance(AuthEnums.AuthType.Company, {
      responseType: "arraybuffer",
    })
      .VoucherImagesClient.GetPdf(id)
      .then((res) => {
        FileHelper.download(res);
      });
  };

  const getVoucherImage = (attachmentId: number | string) => {
    return ApiClientInstance(AuthEnums.AuthType.Company)
      .VoucherImagesClient.Get(attachmentId as string)
      .then((res) => res.data.data ?? "");
  };

  return { getVoucher, getSeries, postVoucher, downloadVoucher, getVoucherImage };
}

export default useVoucherService;
